module.exports = __webpack_public_path__ + "img/noun-anxiety-4660868.221538d9.svg";